export default function getProductType() {
  const isDesktop = window.matchMedia('only screen and (min-width: 650px)');
  return isDesktop.matches ? 'web' : 'web-mobile';
}